<template>
  <b-container class="not-found">
    <div class="content-box constricted">
      <h1 class="text-center title m-3" :class="settings?.title?.class" :style="settings?.title?.style">
        {{ settings?.title?.text || 'Loading...' }}
      </h1>
      <span class="d-flex justify-content-center text-center d-flex content" :class="settings?.sub_title?.class"
        :style="settings?.sub_title?.style">
        {{ settings?.sub_title?.text || 'Please wait, the page is currently loading.' }}
      </span>
      <div class="m-4 text-center" v-if="settings?.spinner">
        <font-awesome-icon :icon="['fa', 'circle-notch']" class="fa-spin m-auto spinner fa-4x" />
      </div>
      <h5 class="d-flex justify-content-center text-center content mt-3" :class="settings?.description?.class"
        :style="settings?.description?.style">
        {{ settings?.description?.text || '' }}
      </h5>
    </div>
  </b-container>
</template>

<script>
export default {
  computed: {
    mode() {
      return this.$route.query.mode;
    },

    settings() {
      return this.$store.state.partners.currentPartner.settings.sections.transition_page?.[this.mode];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/stylesheets/components/transition.scss';
</style>
